/**
 * Actions for the global reusable loan-document upload modal.
 *
 * @param {null | { type: "borrower" | "property", id: string, label?: string }} assignTo
 *   Lock the upload to a specific borrower/property (picker hidden), or null to
 *   upload directly to the loan (picker shown).
 * @param {{ initialView?: "quick_upload" | "group", initialFiles?: Array }} [options]
 *   `initialView` opens the modal on that tab (UPLOAD_TYPES value) instead of
 *   Quick Upload — e.g. the per-record "Upload By Group" button.
 *   `initialFiles` seeds the review queue with files the caller already
 *   collected (a drop on a surface that has no UploadQueueProvider of its own,
 *   e.g. the Add To Loan panel). Same entry shape the dropzones build:
 *   `{ id, file, name, file_display_name }`.
 */
export const docUploadModalOpen = (assignTo = null, options = {}) => ({
  type: "DOC_UPLOAD_MODAL_OPEN",
  payload: {
    assignTo,
    initialView: options?.initialView ?? null,
    initialFiles: options?.initialFiles ?? null,
  },
});

export const docUploadModalClose = () => ({
  type: "DOC_UPLOAD_MODAL_CLOSE",
});
